/** @jsx jsx */
import { jsx, Flex, Heading, Text, Image } from 'theme-ui';
import { LearnMore } from 'components/link';
import { rgba } from 'polished';

const Post = ({ post }) => {
  return (
    <article sx={styles.post}>
      {post.image && (
      <Flex as="figure">
        <Image src={post.image.url} alt={post.image.description} />
      </Flex>
      )}
      <Heading as="h4">{post.title}</Heading>
      {post.snippet && <Text as="p">{post.snippet}</Text>}
      {post.id != null && <LearnMore path={"/post/" + post.id} label="Read More" />}
    </article>
  );
};

export default Post;

const styles = {
  post: {
    paddingLeft: 3,
    paddingRight: 3,
    marginBottom: 6,
    width: ['100%', null, null, '50%', '33.3333%'],
    figure: {
      margin: 0,
      img: {
        borderRadius: 5,
        width: '100%',
      },
    },
    h4: {
      color: 'white',
      fontWeight: 700,
      fontSize: [2, null, null, 4, '17px', 4],
      lineHeight: 1.5,
      mt: 3,
    },
    p: {
      color: rgba('white', 0.8),
      fontSize: [1, null, null, 2],
      marginTop: 3,
    },
    a: {
      color: rgba('white', 0.8),
      mt: [2, 3, null, 4],
    },
  },
};
